export default {"src":"/_next/static/media/white_bank.5ec010a0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};